export function getTopLevelRoute(url: string): string {
  const urlMatch = url?.match(/[^/]+/g);

  return Array.isArray(urlMatch) && urlMatch.length > 0 ? urlMatch[0] : '';
}
